<div class="ccl-datatable-wrapper">
  <table
    class="ccl-datatable
            {{ striped ? 'ccl-datatable--striped' : '' }}
            {{ bordered ? 'ccl-datatable--bordered' : '' }}
            {{ compact ? 'ccl-datatable--compact' : '' }}"
    role="table"
  >
    <thead>
      @if (parentHeaders.length > 0) {
        <!-- Multi-level Headers: Parent Headers Row -->
        <tr role="row" class="ccl-datatable__parent-header">
          @for (col of columns; track col.id; let i = $index) {
            @if (col.parentHeader) {
              @if (getParentHeaderAt(i)) {
                <th 
                  role="columnheader" 
                  scope="colgroup"
                  [attr.colspan]="getParentHeaderAt(i)!.colspan"
                  class="ccl-datatable__parent-header-cell"
                  [class.ccl-datatable__align-left]="col.align === 'left'"
                  [class.ccl-datatable__align-center]="col.align === 'center' || !col.align"
                  [class.ccl-datatable__align-right]="col.align === 'right'"
                  [ngClass]="getHeaderBorderClasses(col)"
                >
                  {{ col.parentHeader }}
                </th>
              }
            } @else {
              <th 
                role="columnheader" 
                scope="colgroup" 
                class="ccl-datatable__parent-header-cell"
                [class.ccl-datatable__sortable]="col.sortable"
                [class.ccl-datatable__align-left]="col.align === 'left'"
                [class.ccl-datatable__align-center]="col.align === 'center' || !col.align"
                [class.ccl-datatable__align-right]="col.align === 'right'"
                [ngClass]="getHeaderBorderClasses(col)"
                [style.width]="col.width || 'auto'"
                rowspan="2"
                (click)="onHeaderClick(col)"
              >
                <span class="ccl-datatable__header">
                  <span class="ccl-datatable__header-label">{{ col.label }}</span>
                  @if (col.sortable) {
                    <span class="ccl-datatable__sort-indicator" [attr.aria-hidden]="true">
                      <span class="ccl-datatable__arrow ccl-datatable__arrow--up" [class.active]="sortId === col.id && sortDirection === 'asc'">▲</span>
                      <span class="ccl-datatable__arrow ccl-datatable__arrow--down" [class.active]="sortId === col.id && sortDirection === 'desc'">▼</span>
                    </span>
                  }
                </span>
              </th>
            }
          }
        </tr>
        
        <!-- Multi-level Headers: Child Headers Row -->
        <tr role="row">
          @for (col of columns; track col.id) {
            @if (!col.parentHeader) {
              <!-- Skip columns without parent header as they're already rendered in parent row -->
            } @else {
              <th 
                role="columnheader" 
                scope="col" 
                [style.width]="col.width || 'auto'"
                [class.ccl-datatable__sortable]="col.sortable"
                [class.ccl-datatable__align-left]="col.align === 'left'"
                [class.ccl-datatable__align-center]="col.align === 'center' || !col.align"
                [class.ccl-datatable__align-right]="col.align === 'right'"
                [ngClass]="getHeaderBorderClasses(col)"
                (click)="onHeaderClick(col)"
              >
                <span class="ccl-datatable__header">
                  <span class="ccl-datatable__header-label">{{ col.label }}</span>
                  @if (col.sortable) {
                    <span class="ccl-datatable__sort-indicator" [attr.aria-hidden]="true">
                      <span class="ccl-datatable__arrow ccl-datatable__arrow--up" [class.active]="sortId === col.id && sortDirection === 'asc'">▲</span>
                      <span class="ccl-datatable__arrow ccl-datatable__arrow--down" [class.active]="sortId === col.id && sortDirection === 'desc'">▼</span>
                    </span>
                  }
                </span>
              </th>
            }
          }
        </tr>
      } @else {
        <!-- Single-level Headers: Regular Headers Row -->
        <tr role="row">
          @for (col of columns; track col.id) {
            <th 
              role="columnheader" 
              scope="col" 
              [style.width]="col.width || 'auto'"
              [class.ccl-datatable__sortable]="col.sortable"
              [class.ccl-datatable__align-left]="col.align === 'left'"
              [class.ccl-datatable__align-center]="col.align === 'center' || !col.align"
              [class.ccl-datatable__align-right]="col.align === 'right'"
              [ngClass]="getHeaderBorderClasses(col)"
              (click)="onHeaderClick(col)"
            >
              <span class="ccl-datatable__header">
                <span class="ccl-datatable__header-label">{{ col.label }}</span>
                @if (col.sortable) {
                  <span class="ccl-datatable__sort-indicator" [attr.aria-hidden]="true">
                    <span class="ccl-datatable__arrow ccl-datatable__arrow--up" [class.active]="sortId === col.id && sortDirection === 'asc'">▲</span>
                    <span class="ccl-datatable__arrow ccl-datatable__arrow--down" [class.active]="sortId === col.id && sortDirection === 'desc'">▼</span>
                  </span>
                }
              </span>
            </th>
          }
        </tr>
      }
    </thead>
    <tbody>
      @if (!rows || rows.length === 0) {
        <tr>
          <td [attr.colspan]="columns.length" class="ccl-datatable__empty">No data available.</td>
        </tr>
      }
      @for (item of groupedRows; track item.groupKey || $index) {
        @if (item.isGroup) {
          <!-- Group Header Row -->
          <tr class="ccl-datatable__group-header" [class.ccl-datatable__group-collapsible]="groupCollapsible">
            <td [attr.colspan]="columns.length" class="ccl-datatable__group-cell">
              @if (groupHeaderTemplate) {
                <ng-container
                  *ngTemplateOutlet="groupHeaderTemplate; context: { $implicit: item.groupValue, groupKey: item.groupKey, rows: item.rows }"
                ></ng-container>
              } @else {
                <div class="ccl-datatable__group-content">
                  @if (groupCollapsible) {
                    <button 
                      type="button"
                      class="ccl-datatable__group-toggle"
                      (click)="toggleGroup(item.groupKey!)"
                      [attr.aria-expanded]="isGroupExpanded(item.groupKey!)"
                    >
                      <span class="ccl-datatable__group-icon" [class.expanded]="isGroupExpanded(item.groupKey!)">▶</span>
                    </button>
                  }
                  <span class="ccl-datatable__group-label">{{ item.groupValue }} ({{ item.rows!.length }} items)</span>
                </div>
              }
            </td>
          </tr>
          <!-- Group Rows -->
          @if (isGroupExpanded(item.groupKey!)) {
            @for (row of item.rows!; track $index) {
              <tr role="row" class="ccl-datatable__group-row">
                @for (col of columns; track col.id) {
                  <td
                    [ngClass]="getClass(col, row) + ' ' + getCellBorderClasses(col)"
                    [ngStyle]="getStyle(col, row)"
                    (click)="handleClick(col, row, row[col.id])"
                    role="cell"
                  >
                    @if (col.template) {
                      <ng-container
                        *ngTemplateOutlet="col.template; context: { $implicit: row[col.id], row: row }"
                      ></ng-container>
                    } @else if (col.link) {
                      <a
                        [href]="col.link(row)"
                        class="ccl-datatable__link"
                        (click)="$event.stopPropagation()"
                      >
                        {{ row[col.id] ?? '' }}
                      </a>
                    } @else {
                      {{ row[col.id] ?? '' }}
                    }
                  </td>
                }
              </tr>
            }
          }
        } @else {
          <!-- Regular Row (when not grouped) -->
          <tr role="row">
            @for (col of columns; track col.id) {
              <td
                [ngClass]="getClass(col, item.rows![0]) + ' ' + getCellBorderClasses(col)"
                [ngStyle]="getStyle(col, item.rows![0])"
                (click)="handleClick(col, item.rows![0], item.rows![0][col.id])"
                role="cell"
              >
                @if (col.template) {
                  <ng-container
                    *ngTemplateOutlet="col.template; context: { $implicit: item.rows![0][col.id], row: item.rows![0] }"
                  ></ng-container>
                } @else if (col.link) {
                  <a
                    [href]="col.link(item.rows![0])"
                    class="ccl-datatable__link"
                    (click)="$event.stopPropagation()"
                  >
                    {{ item.rows![0][col.id] ?? '' }}
                  </a>
                } @else {
                  {{ item.rows![0][col.id] ?? '' }}
                }
              </td>
            }
          </tr>
        }
      }
    </tbody>
  </table>
</div>
